import { Link, BrowserRouter as Router, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import getAllDetails from "./aws.js"
import "./Home.css";
import MediaCard from "./Card";

import Button from "@material-ui/core/Button";

export default function Home() {
  const [loading, setloading] = useState(false);
  const [Data, setData] = useState([]);
  const category = [
    { name: "Business", value: "business" },
    { name: "Entertainment", value: "entertainment" },
    { name: "Health", value: "health" },
    { name: "Science", value: "science" },
    { name: "Sports", value: "sports" },
    { name: "Technology", value: "technology" },
  ];

  const search = useLocation().search;

  const categoryname = new URLSearchParams(search).get("category");

  useEffect(() => {
    async function GetData() {
      try {
        var _data = await (await getAllDetails).Items;
        _data.sort(function(a,b){
          return new Date(b.publishedAt) - new Date(a.publishedAt);
        });
        console.log(_data);
          setData(_data);
          setloading(true);
      } catch (error) {
        console.log(error);
      }
    }
    GetData();
  }, []);


  return (
    <div>
      <Router browserHistory>
        {(!loading && (
          <div
            style={{
              width: "100%",
              height: "100vh",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Loader type="Audio" color="red" height={100} width={100} />
          </div>
        )) || (
          <div>
            <div className="row">
              <div className="column1">
                <Link to="/">
                  <Button
                    style={{
                      color: "white",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "20px",
                      marginTop: "20px",
                    }}
                  >
                    Daily News
                  </Button>
                </Link>
                <ul>
                  <li className="subcat1">Categories</li>

                  {category.map((data, index) => (
                    <Link
                      to={{ search: "&category=" + data.value }}
                      key={index}
                    >
                      <li
                        onClick="window.location.href=window.location.href"
                        className="subcat"
                      >
                        {data.name}
                      </li>
                    </Link>
                  ))}
                </ul>
              </div>

              <div className="column2">
                <div className="categoryname">
                  <h1>{categoryname===null ? "Select any category":categoryname+" News"} </h1>
                </div>
                <div className="category">
                  <Link to={{ search: "&category=busniess" }}>
                    <div
                      onClick="window.location.href=window.location.href"
                      className="cat"
                    >
                      <p>Business</p>
                    </div>
                  </Link>
                  <Link to={{ search: "&category=entertainment" }}>
                    <div
                      onClick="window.location.href=window.location.href"
                      className="cat"
                    >
                      <p>Entertainment</p>
                    </div>
                  </Link>
                  <Link to={{ search: "&category=health" }}>
                    <div
                      onClick="window.location.href=window.location.href"
                      className="cat"
                    >
                      <p>Health</p>
                    </div>
                  </Link>
                  <Link to={{ search: "&category=science" }}>
                    <div
                      onClick="window.location.href=window.location.href"
                      className="cat"
                    >
                      <p>Science</p>
                    </div>
                  </Link>
                  <Link to={{ search: "&category=sports" }}>
                    <div
                      onClick="window.location.href=window.location.href"
                      className="cat"
                    >
                      <p>Sports</p>
                    </div>
                  </Link>
                  <Link to={{ search: "&category=technology" }}>
                    <div
                      onClick="window.location.href=window.location.href"
                      className="cat"
                    >
                      <p>Technology</p>
                    </div>
                  </Link>
                </div>
                {Data.length === 0 ? (
                  <div className="New">
                    <h1>Select any category to find the News</h1>
                  </div>
                ) : (
                    <div className="grid-container">
                  {Data.map((data) => {
                    if (data.category === categoryname) {
                      return (
                        <div className="grid-item">
                          <MediaCard
                            results={JSON.stringify({
                              Url: data.urlToImage,
                              Name: data.author,
                              Title: data.title,
                              Weburl: data.url,
                            })}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Router>
    </div>
  );
}
